import Login from '@/views/public/auth/Login.vue';

export default [{
  path: '/login',
  name: 'app.login',
  component: Login,
  meta: {
    auth: false,
  },
}];
